import { PROP_TYPES, propValidator } from '@/utils/validators'
import { USER_STATUS, USER_TYPE } from 'enums/users'
import { mapGetters } from 'vuex'

export default {
  props: {
    Id: propValidator([PROP_TYPES.STRING]),
    PhotoUrl: propValidator([PROP_TYPES.STRING], false),
    FirstName: propValidator([PROP_TYPES.STRING]),
    LastName: propValidator([PROP_TYPES.STRING]),
    Job: propValidator([PROP_TYPES.STRING]),
    Role: propValidator([PROP_TYPES.STRING], true, null, role =>
      Object.values(USER_TYPE).includes(role)
    ),
    Status: propValidator([PROP_TYPES.STRING], true, null, status =>
      Object.values(USER_STATUS).includes(status)
    ),
    Company: propValidator([PROP_TYPES.STRING], false),
    Bio: propValidator([PROP_TYPES.STRING]),
    FacebookUrl: propValidator([PROP_TYPES.STRING], false),
    TwitterUrl: propValidator([PROP_TYPES.STRING], false),
    LinkedInUrl: propValidator([PROP_TYPES.STRING], false),
    TelegramUrl: propValidator([PROP_TYPES.STRING], false),
    Email: propValidator([PROP_TYPES.STRING]),
    IsFollowed: propValidator([PROP_TYPES.BOOLEAN]),
    ArticleCount: propValidator([PROP_TYPES.NUMBER], false),
    FollowerCount: propValidator([PROP_TYPES.NUMBER], false)
  },
  computed: {
    ...mapGetters({
      userDetails: 'auth/userDetails'
    }),
    fullName() {
      return `${this.FirstName} ${this.LastName}`
    },
    isAuthorNotCurrentUser() {
      return (
        !this.userDetails.Id ||
        (this.userDetails.Id && this.Id && this.userDetails.Id !== this.Id)
      )
    },
    isFollowAuthorButtonVisible() {
      return (
        this.isAuthorNotCurrentUser &&
        this.Status === USER_STATUS.ACTIVE &&
        this.Role !== USER_TYPE.SUBSCRIBER
      )
    }
  },
  mounted() {
    this.$emit('mounted')
  }
}
